import { useCompany } from "@admin/hooks/useCompany";
import {
  categorizeFoodControlPoints,
  CompanyLocation,
  ControlPointCategory,
  FoodControlPoint,
  FoodControlPointInstanceDto,
  FoodManagementControls,
} from "@enos-monorepo/lib";
import { useMemo } from "react";

import { AllControlsTable } from "..";
import { GeneralCleaningControls } from "./GeneralCleaningControls";

interface AllControlsProps {
  controlPoints?: FoodControlPoint[];
  controls: FoodControlPointInstanceDto[];
  selectedLocation?: CompanyLocation;
}

export function AllControls({
  controlPoints,
  controls,
  selectedLocation,
}: AllControlsProps) {
  const { company } = useCompany();

  // add cleaning floor and cleaning hood if they are not already in the list
  const groupedControls = useMemo(
    () => categorizeFoodControlPoints(controls),
    [controls],
  );

  return (
    <div className="flex flex-col gap-5">
      {Object.keys(groupedControls)
        .filter((type) => type !== "Unknown Category")
        .map((type, index) => (
          <div key={`AllControls-${index}`} className="flex flex-col gap-5">
            <AllControlsTable
              type={type as ControlPointCategory}
              controlsOfType={groupedControls[type as ControlPointCategory]}
            />
            {type === "Food Processing Controls" && (
              <GeneralCleaningControls
                controlPoints={controlPoints?.filter(
                  (cp) =>
                    cp.type === FoodManagementControls.cleaningFloor ||
                    cp.type === FoodManagementControls.cleaningHood,
                )}
                selectedLocation={selectedLocation}
                companyId={company?.companyId}
              />
            )}
          </div>
        ))}
    </div>
  );
}
